export default "__VITE_ASSET__66dffee6__"